var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect } from 'react';
import { dAxios, snackBarRsp, daFormatTrans, YNOpTrs } from 'consts';
import { inputChange, checkboxChange, datePickerChange, radioChange, } from 'component/consts';
import { chtNum, HOST } from 'config';
import { useSnackbar } from 'notistack';
import { ButtonContain, ButtonContainO, } from 'component/material/ButtonContained/Button';
import { ButtonBar } from 'component/material/ButtonContained/ButtonBar';
import Input, { GreenCheck } from 'component/material/Input';
import { MasterGrids2, VcGrid } from 'component/LHH/MasterGrids/MasterGrids';
import CheckBox from 'component/material/Checkbox';
import PopDialog from 'component/LHH/PopDialog/PopDialog';
import { fullBrowserVersion, browserName } from 'react-device-detect';
import Radio from 'component/material/Radio';
import InputChtName, { chtNameError, } from 'component/material/Input/InputChtName';
import DatePicker from 'component/material/DatePicker';
import InputEngNum, { EngNumCheck } from 'component/material/Input/InputEngNum';
import InputCellPhone, { CellPhoneCheck, } from 'component/material/Input/InputCellPhone';
import InputNum from 'component/material/Input/InputNum';
import { PinCheck } from 'component/material/Input/InputPin';
import InputEngName, { EngNameError, } from 'component/material/Input/InputEngName';
import { useDispatch } from 'react-redux';
import { setLoadingRedux } from 'reducers/sharedata/action';
import Button from '@material-ui/core/Button';
import { PageTypeEnum } from 'reducers/sharedata/types';
import DateEnum from 'component/material/DatePicker/enum';
// eslint-disable-next-line @typescript-eslint/no-var-requires
var mainStyle = require('main_style.module.css');
// component --------------------------------------------------------------------------
var PersonDlg = function (props) {
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var _a = props._userData, setUserData = _a[1], show = props._show[0], onConfirm = props.onConfirm, onClose = props.onClose;
    var _b = useState(''), divText = _b[0], setDivText = _b[1];
    var getAnnouncement = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dAxios('get', HOST + "v1/system/announcement", { source: 'W', type: 'P', lang: 'TW' }, enqueueSnackbar)];
                case 1:
                    response = _a.sent();
                    if (!snackBarRsp(enqueueSnackbar, response)) {
                        return [2 /*return*/];
                    }
                    if ((response === null || response === void 0 ? void 0 : response.data.status) === 'Y') {
                        setUserData(function (prev) { return (__assign(__assign({}, prev), { version: response.data.data[0].version })); });
                        setDivText(response.data.data[0].context);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        getAnnouncement();
    }, []);
    var DlgConfig = {
        show: show,
        escExit: true,
        width: '50vw',
        title: '個資宣告同意書',
        handleExit: onClose,
        children: (React.createElement("div", null,
            React.createElement("div", { 
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: { __html: divText }, style: { fontSize: '1.2em' } }),
            React.createElement(ButtonBar, null,
                React.createElement(ButtonContain, { variant: "outlined", onClick: onClose }, "\u53D6\u6D88"),
                React.createElement(ButtonContain, { onClick: onConfirm }, "\u540C\u610F")))),
    };
    return React.createElement(PopDialog, __assign({}, DlgConfig));
};
var UserForm = function (props) {
    var dispatch = useDispatch();
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var _a = props._userData, userData = _a[0], setUserData = _a[1], history = props.history, setPageShow = props.setPageShow;
    var _b = useState(false), verifyError = _b[0], setVerifyError = _b[1];
    var _c = useState(false), verifyError2 = _c[0], setVerifyError2 = _c[1];
    var _d = useState(false), verCodeShow = _d[0], setVerCodeShow = _d[1];
    var _e = useState(0), smsTime = _e[0], setSmsTime = _e[1];
    var _f = useState(-1), smsTick = _f[0], setSmsTick = _f[1];
    var interval;
    var _g = useState(false), smsDisable = _g[0], setSmsDisable = _g[1];
    var _h = useState(false), submitBtn = _h[0], setSubmitBtn = _h[1];
    var _j = useState(''), userIdMsg = _j[0], setUserIdMsg = _j[1];
    var _k = useState(''), verCodeMsg = _k[0], setVerCodeMsg = _k[1];
    var _l = useState(''), userPwd2Err = _l[0], setUserPwd2KErr = _l[1];
    // const
    var isResident = userData.certificateType === 'R'; // 居留證
    var isTwId = userData.certificateType === 'C'; // 身分證
    var isChina = userData.isChina === 'Y'; // 中國人
    var chtNameRequried = isTwId || isChina; // 台灣人 或 中國人
    var engNameRequried = !isTwId && !isChina; // 外國人(非中國)
    var updateData = function (updateObj) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setUserData(function (prev) { return (__assign(__assign({}, prev), updateObj)); });
            return [2 /*return*/];
        });
    }); };
    var userIdCheck = function (value) {
        return value.length >= 3 && value.length <= 15 && EngNumCheck(value);
    };
    var userIdOnChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    inputChange(updateData)(e);
                    if (!(e.target.value.length >= 3)) return [3 /*break*/, 2];
                    return [4 /*yield*/, dAxios('get', HOST + "v1/user/user-id", {
                            userType: 'EZWAY',
                            userId: e.target.value,
                            lang: 'TW',
                        }, enqueueSnackbar)];
                case 1:
                    response = _a.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data.status) === 'N') {
                        setUserIdMsg(response === null || response === void 0 ? void 0 : response.data.msg);
                        return [2 /*return*/];
                    }
                    _a.label = 2;
                case 2:
                    setUserIdMsg('');
                    return [2 /*return*/];
            }
        });
    }); };
    var smsCheck = function () {
        setVerifyError(true);
        if (
        // certificateType === 'C' || isChina === 'Y' ， userName 必填
        (chtNameRequried && !userData.userName) ||
            // userName 非空時，必檢查
            (userData.userName &&
                (chtNameError(chtNum)(userData.userName) ||
                    userData.userName.length > 50)) ||
            // certificateType !== 'C' && isChina ==="N" ， userNameE 必填
            (engNameRequried && !userData.userNameE) ||
            // userName 非空時，必檢查
            (userData.userNameE &&
                (EngNameError(userData.userNameE) || userData.userNameE.length > 80)) ||
            (!isTwId && !userData.expiryDate) ||
            (isTwId && !PinCheck(userData.idNo || '')) ||
            (!isTwId && !EngNumCheck(userData.idNo || '')) ||
            !(userIdCheck(userData.userId) && userIdMsg.length === 0) ||
            // datepicker readonly not validte required by form
            !userData.birthDate ||
            (!isTwId && !userData.expiryDate) ||
            (!(userData.userPwd.length >= 5 && userData.userPwd.length <= 30) &&
                EngNumCheck(userData.userPwd)) ||
            !(userData.userPwd === userData.userPwd2) ||
            !(userData.email.length <= 50 && userData.email.indexOf('@') > -1) ||
            !(userData.address.length <= 200) ||
            !CellPhoneCheck(userData.telNo) ||
            !(userData.personCheck === 'Y')) {
            return false;
        }
        return true;
    };
    var smsBtnControl = function () {
        setSmsDisable(true);
        setSmsTick(60);
        interval = setInterval(function () {
            setSmsTick(function (prev) {
                if (prev === 0 && smsTime < 1) {
                    setSmsDisable(false);
                    clearInterval(interval);
                }
                return prev - 1;
            });
        }, 1000);
    };
    var handleSMS = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setVerifyError2(false);
                    if (e && e.preventDefault) {
                        e.preventDefault();
                    }
                    if (!smsCheck()) {
                        return [2 /*return*/];
                    }
                    if (smsTime === 2) {
                        return [2 /*return*/];
                    }
                    smsBtnControl();
                    setSmsTime(function (pre) { return pre + 1; });
                    dispatch(setLoadingRedux(1));
                    return [4 /*yield*/, dAxios('POST', HOST + "v1/realname/sms/ver-code", __assign(__assign({}, userData), { deviceType: 'W', msgFuncCode: '1', lang: 'TW' }), enqueueSnackbar)];
                case 1:
                    response = _a.sent();
                    dispatch(setLoadingRedux(-1));
                    if (!snackBarRsp(enqueueSnackbar, response)) {
                        return [2 /*return*/];
                    }
                    if ((response === null || response === void 0 ? void 0 : response.data.status) === 'Y') {
                        setVerCodeShow(true);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var verCodeChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var verCode, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    inputChange(updateData)(e);
                    verCode = e.target.value;
                    if (!(verCode.length === 6)) return [3 /*break*/, 2];
                    dispatch(setLoadingRedux(1));
                    return [4 /*yield*/, dAxios('post', HOST + "v1/realname/sms/check", __assign(__assign({}, userData), { deviceType: 'W', verCode: verCode, lang: 'TW' }), enqueueSnackbar)];
                case 1:
                    response = _a.sent();
                    dispatch(setLoadingRedux(-1));
                    if (!snackBarRsp(enqueueSnackbar, response)) {
                        return [2 /*return*/];
                    }
                    if ((response === null || response === void 0 ? void 0 : response.data.status) === 'Y') {
                        setSubmitBtn(true);
                        setVerCodeMsg('');
                    }
                    else {
                        setSubmitBtn(false);
                        setVerCodeMsg((response === null || response === void 0 ? void 0 : response.data.msg) || '');
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var submitCheck2 = function () {
        setVerifyError2(true);
        if (!(userData.verCode.length === 6 && verCodeMsg.length === 0)) {
            return false;
        }
        return true;
    };
    var handleStore = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (e && e.preventDefault) {
                        e.preventDefault();
                    }
                    if (!smsCheck()) {
                        return [2 /*return*/];
                    }
                    if (!submitCheck2()) {
                        return [2 /*return*/];
                    }
                    dispatch(setLoadingRedux(1));
                    return [4 /*yield*/, dAxios('POST', HOST + "v1/system/api-log", {
                            userId: userData.userId,
                            osVersion: fullBrowserVersion,
                            deviceName: browserName,
                            deviceModel: '',
                            phoneNo: userData.telNo,
                            logDate: daFormatTrans(new Date(), DateEnum.daTiFormatN),
                            functionCode: 'P01',
                            functionTransactionId: '',
                            version: '',
                            piVersion: userData.version,
                            lang: userData.lang,
                        }, enqueueSnackbar)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, dAxios('POST', HOST + "v7/user", __assign(__assign({}, userData), { createId: userData.userId }), enqueueSnackbar)];
                case 2:
                    response = _a.sent();
                    dispatch(setLoadingRedux(-1));
                    if (!snackBarRsp(enqueueSnackbar, response)) {
                        return [2 /*return*/];
                    }
                    if ((response === null || response === void 0 ? void 0 : response.data.status) === 'Y')
                        setPageShow(PageTypeEnum.detail);
                    return [2 /*return*/];
            }
        });
    }); };
    var QueryConds = [
        {
            t: '*持有證件',
            colspan: isResident ? 1 : 2,
            child: (React.createElement(Radio, { disabled: true, required: true, verifyBeforeChange: verifyError, name: "certificateType", value: userData.certificateType || '', onChange: function () { return undefined; }, options: [
                    { value: 'C', label: '身分證' },
                    { value: 'R', label: '居留證' },
                ] })),
        },
        {
            t: (React.createElement(React.Fragment, null,
                "\u662F\u5426\u70BA\u5927\u9678\u5730\u5340",
                React.createElement("br", null),
                "\u53CA\u9999\u6E2F\u6FB3\u9580\u4EBA\u6C11")),
            show: isResident,
            child: (React.createElement(Radio, { disabled: true, required: true, verifyBeforeChange: verifyError, name: "isChina", value: userData.isChina || '', onChange: radioChange(updateData), options: YNOpTrs.options })),
        },
        {
            t: (chtNameRequried ? '*' : '') + "\u4E2D\u6587\u59D3\u540D",
            child: (React.createElement(InputChtName, { className: mainStyle.input, chtNum: chtNum, required: chtNameRequried, verifyBeforeChange: userData.userName ? true : verifyError, placeholder: "\u8ACB\u8F38\u5165\u8207\u8EAB\u5206\u8B49\u865F\u78BC\u767B\u8A18\u76F8\u540C\u7684\u4E2D\u6587\u59D3\u540D", inputProps: { maxLength: 50 }, value: userData.userName || '', name: "userName", onChange: inputChange(updateData) })),
        },
        {
            t: (engNameRequried ? '*' : '') + "\u82F1\u6587\u59D3\u540D",
            child: (React.createElement(InputEngName, { className: mainStyle.input, required: engNameRequried, verifyBeforeChange: userData.userNameE ? true : verifyError, placeholder: "\u8ACB\u8F38\u5165\u8207\u5C45\u7559\u8B49\u865F\u78BC\u767B\u8A18\u76F8\u540C\u7684\u82F1\u6587\u59D3\u540D", inputProps: { maxLength: 80 }, value: userData.userNameE || '', name: "userNameE", onChange: inputChange(updateData) })),
        },
        {
            t: isTwId ? '*身分證號碼' : '*居留證號碼',
            child: (React.createElement(Input, { className: mainStyle.input, disabled: true, value: userData.idNo || '', name: "idNo" })),
        },
        {
            t: '*帳號',
            child: (React.createElement(InputEngNum, { className: mainStyle.input, required: true, verifyBeforeChange: verifyError, minLength: 5, maxLength: 30, 
                // placeholder="請輸入英數字，長度可接受5~30碼"
                InputProps: userIdMsg.length === 0 && userData.userId.length >= 5
                    ? { endAdornment: React.createElement(GreenCheck, null) }
                    : {}, error: userIdMsg.length > 0, helperText: userIdMsg, value: userData.userId || '', name: "userId", onChange: userIdOnChange })),
        },
        {
            t: '*出生年月日',
            colspan: isTwId ? 2 : 1,
            child: (React.createElement(DatePicker, { className: mainStyle.input, required: true, verifyBeforeChange: verifyError, format: DateEnum.daFormatP, name: "birthDate", value: daFormatTrans(userData.birthDate || ''), onChange: datePickerChange(updateData)('birthDate') })),
        },
        {
            t: '*居留證有效日期',
            show: !isTwId,
            child: (React.createElement(DatePicker, { className: mainStyle.input, required: true, verifyBeforeChange: verifyError, format: DateEnum.daFormatP, name: "expiryDate", value: daFormatTrans(userData.expiryDate || ''), onChange: datePickerChange(updateData)('expiryDate') })),
        },
        // {
        //   t: '健保卡卡號',
        //   show: isTwId,
        //   colspan: 2,
        //   child: (
        //     <Input
        //       className={mainStyle.input}
        //       placeholder="請輸入"
        //       inputProps={{ maxLength: 12 }}
        //       value={userData.nhiCard || ''}
        //       name="nhiCard"
        //       onChange={inputChange(updateData)}
        //     />
        //   ),
        // },
        {
            t: '*設定密碼',
            child: (React.createElement(InputEngNum, { className: mainStyle.input, type: "password", required: true, verifyBeforeChange: verifyError, placeholder: "\u5BC6\u78BC\u9577\u5EA6\u81F3\u5C118\u78BC(\u542B)\u4EE5\u4E0A", inputProps: { minLength: 5, maxLength: 30 }, value: userData.userPwd || '', name: "userPwd", helperText: React.createElement("span", { style: { color: 'red', fontSize: 15 } },
                    React.createElement("div", null,
                        "\u5BC6\u78BC\u8A2D\u5B9A\u9700\u7B26\u5408\u4E0B\u52175\u9805\u898F\u5247 ",
                        React.createElement("br", null),
                        "\u00A0\u00A0 \uFF0E\u5305\u542B\u82F1\u6587\u5927\u5BEB\u3002 ",
                        React.createElement("br", null),
                        "\u00A0\u00A0 \uFF0E\u5305\u542B\u82F1\u6587\u5C0F\u5BEB\u3002 ",
                        React.createElement("br", null),
                        "\u00A0\u00A0 \uFF0E\u5305\u542B\u6578\u5B57\u3002 ",
                        React.createElement("br", null),
                        "\u00A0\u00A0 \uFF0E\u5305\u542B\u7279\u6B8A\u7B26\u865F\u3010\u50C5\u9650\uFF20\uFF04\uFF01\uFF05\uFF0A\uFF1F\uFF03\u3011 \u3002 ",
                        React.createElement("br", null),
                        "\u00A0\u00A0 \uFF0E\u9577\u5EA6\u81F3\u5C118~30\u78BC\u5B57\u5143 \u3002")), onChange: function (e) {
                    if (e.target.value !== userData.userPwd2)
                        setUserPwd2KErr('請再次輸入密碼。');
                    else
                        setUserPwd2KErr('');
                    inputChange(updateData)(e);
                } })),
        },
        {
            t: '*再次輸入密碼',
            child: (React.createElement(InputEngNum, { className: mainStyle.input, type: "password", required: true, verifyBeforeChange: verifyError, error: userPwd2Err.length > 0, helperText: userPwd2Err, placeholder: "\u8ACB\u518D\u6B21\u8F38\u5165\u5BC6\u78BC", inputProps: { minLength: 5, maxLength: 30 }, value: userData.userPwd2 || '', name: "userPwd2", onChange: function (e) {
                    if (userData.userPwd !== e.target.value)
                        setUserPwd2KErr('請再次輸入密碼。');
                    else
                        setUserPwd2KErr('');
                    inputChange(updateData)(e);
                } })),
        },
        {
            t: '*Email',
            colspan: 2,
            child: (React.createElement(Input, { className: mainStyle.input, type: "email", required: true, verifyBeforeChange: verifyError, placeholder: "\u70BA\u907F\u514D\u88AB\u8996\u70BA\u5783\u573E\u90F5\u4EF6\uFF0C\u9020\u6210\u7121\u6CD5\u6536\u4FE1\u7684\u56F0\u64FE\uFF0C\u8ACB\u76E1\u91CF\u907F\u514D\u4F7F\u7528 Yahoo \u6216 Hotmail \u4FE1\u7BB1", inputProps: { maxLength: 50 }, value: userData.email || '', name: "email", onChange: function (e) {
                    e.target.value = e.target.value.toUpperCase(); // 轉為大寫
                    inputChange(updateData)(e);
                } })),
        },
        {
            t: '地址',
            colspan: 2,
            child: (React.createElement(Input, { className: mainStyle.input, placeholder: "\u8ACB\u8F38\u5165", inputProps: { maxLength: 200 }, value: userData.address || '', name: "address", onChange: inputChange(updateData) })),
        },
        {
            t: '*手機號碼',
            colspan: 2,
            child: (React.createElement(VcGrid, { container: true },
                React.createElement(VcGrid, { item: true, sm: true },
                    React.createElement(InputCellPhone, { className: mainStyle.input, required: true, verifyBeforeChange: verifyError, placeholder: "\u8ACB\u8F38\u5165\u5E33\u865F\u64C1\u6709\u8005\u7684\u624B\u6A5F\u865F\u78BC", value: userData.telNo || '', name: "telNo", onChange: inputChange(updateData) })),
                React.createElement(VcGrid, { item: true, sm: true, className: mainStyle.flexVerticalCenter },
                    React.createElement(ButtonContainO, { type: !submitBtn ? 'submit' : 'button', onClick: !submitBtn ? undefined : handleSMS, disabled: smsDisable, size: "small" },
                        "\u50B3\u9001\u7C21\u8A0A\u78BC",
                        smsTick > -1 && smsTime < 2 && "(" + smsTick + ")"),
                    React.createElement("span", { style: { marginLeft: 5 } }, " \u9A57\u8B49\u78BC\u6700\u591A\u91CD\u767C\u4E8C\u6B21 ")))),
        },
        {
            t: '*驗證碼',
            colspan: 2,
            show: verCodeShow && userData.telNo.length === 10,
            child: (React.createElement(VcGrid, { container: true },
                React.createElement(VcGrid, { item: true, sm: 6 },
                    React.createElement(InputNum, { className: mainStyle.input, autoFocus: true, required: verifyError2, verifyBeforeChange: verifyError2, placeholder: "\u8ACB\u8F38\u5165\u50B3\u9001\u7D66\u60A8\u76846\u4F4D\u9A57\u8B49\u78BC", minLength: 6, maxLength: 6, InputProps: verCodeMsg.length === 0 && userData.verCode.length === 6
                            ? { endAdornment: React.createElement(GreenCheck, null) }
                            : {}, error: verCodeMsg.length > 0, helperText: verCodeMsg, value: userData.verCode || '', name: "verCode", onChange: verCodeChange })),
                React.createElement(VcGrid, { item: true, sm: 6, className: mainStyle.flexVerticalCenter }, "\u8ACB\u65BC 5 \u5206\u9418\u5167\u8F38\u5165\u5BC6\u78BC\u4EE5\u5B8C\u6210\u8A8D\u8B49\u7A0B\u5E8F"))),
        },
    ];
    var _m = useState(false), PersonShow = _m[0], setPersonShow = _m[1];
    var handleSuccess = function () {
        setPersonShow(function (prev) { return !prev; });
        updateData({ personCheck: 'Y' });
    };
    var handleClose = function () {
        setPersonShow(function (prev) { return !prev; });
        if (userData.personCheck !== 'Y')
            enqueueSnackbar('請確認個資宣告內容。');
    };
    return (React.createElement("div", null,
        React.createElement(PersonDlg, { _userData: [userData, setUserData], _show: [PersonShow, setPersonShow], onConfirm: handleSuccess, onClose: handleClose }),
        React.createElement("div", { style: { marginBottom: 10 } }, "\u8ACB\u586B\u5BEB\u4E0B\u5217\u8CC7\u6599\uFF1A"),
        React.createElement("form", { onInvalid: 
            // 送出 或 傳送簡訊
            submitBtn ? function () { return setVerifyError2(true); } : function () { return setVerifyError(true); }, onSubmit: 
            // 送出 或 傳送簡訊
            submitBtn ? handleStore : handleSMS },
            React.createElement(MasterGrids2, { mGrids: QueryConds }),
            React.createElement(CheckBox, { label: React.createElement(React.Fragment, null,
                    "\u6211\u5DF2\u95B1\u8B80\u4E14\u540C\u610F",
                    React.createElement(Button, { color: "primary", onClick: function () { return setPersonShow(true); }, style: { padding: '2px', fontSize: '1rem' } }, "\u500B\u8CC7\u5BA3\u544A\u5167\u5BB9"),
                    "\u3002"), required: true, verifyBeforeChange: verifyError, checked: userData.personCheck === 'Y', name: "personCheck", onChange: checkboxChange(updateData)(['Y', 'N']) }),
            React.createElement(ButtonBar, null,
                React.createElement(ButtonContain, { variant: "outlined", onClick: function () { return history.goBack(); } }, "\u53D6\u6D88"),
                React.createElement(ButtonContain, { type: submitBtn ? 'submit' : 'button', onClick: submitBtn ? undefined : handleStore, disabled: !(submitBtn &&
                        userData.personCheck === 'Y' &&
                        userData.verCode.length === 6) }, "\u78BA\u5B9A")))));
};
export default UserForm;
